import React from 'react'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'

import { WebsiteCard } from '../../components/Card/Card'
import { Section } from '../../components/Section'
import { WebsiteText } from '../../components/WebsiteText'
import { useRoutes } from '../../routes'
import { getBrowserExtensionButtonsSteps } from './data'

export function SectionBrowserExtensionButtonsSteps() {
  const intl = useIntl()
  const routes = useRoutes()
  const stepsData = getBrowserExtensionButtonsSteps(intl, routes)

  return (
    <Section containerVerticalPadding={120} background="moon-dust-lighter">
      <WebsiteText
        variant="title"
        className="margin-bottom-40 text-align-center"
      >
        <FormattedMessage
          id="browserExtension.buttons.steps.title"
          defaultMessage="Buttons for your most frequent tasks"
        />
      </WebsiteText>
      <div className="grid-12 grid-gap-24">
        {stepsData.map(({ title, desc, illustration }, index) => (
          <WebsiteCard
            key={index}
            hoverOutline={false}
            className={classNames(
              [0, 1, 2].includes(index)
                ? 'grid-span-4 flexbox flexbox-column grid-span-12-small'
                : 'grid-span-12 flexbox flexbox-column-small',
              'radius-large overflow-hidden border-small border-alpha-shade-40'
            )}
          >
            <div className="padding-top-40 padding-horizontal-40 padding-bottom-40">
              <div
                className={classNames(
                  'font-size-3 font-family-title font-weight-medium line-height-title margin-bottom-12',
                  index === stepsData.length - 1 && 'padding-top-32'
                )}
              >
                {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
                <span className="saturn-orange">{index + 1}. </span>
                {title}
              </div>
              <div className="font-size-5 shade-10">{desc}</div>
            </div>
            {illustration}
          </WebsiteCard>
        ))}
      </div>
    </Section>
  )
}
